<!-- Using custom footer to show the financial quote -->
<ui-modal-full
  title="Add operations task rule"
  [progress]="progress()"
  (backClicked)="handleBack()"
  (closeClicked)="close()">
  @switch (activeStep()) {
    @case ('task-type') {
      <sbnb-add-task-rule-flow-task-type (taskTypeSelected)="onTaskTypeSelected($event)" />
    }
    @case ('manual-task-when') {
      <sbnb-add-task-rule-flow-manual-task-when
        [taskType]="payload().task_type!"
        (whenSelected)="onWhenSelected($event)" />
    }
    @case ('cleaning-auto-manual') {
      <sbnb-add-task-rule-flow-cleaning-auto-manual
        [hasAtLeastOneEligibleAutomatedCleaningProperty]="potentialProperties().length > 0"
        [isOnLegacyPlan]="isOnLegacyPlan()"
        (optionSelected)="onCleaningOptionSelected($event)" />
    }
    @case ('auto-property') {
      <h2 class="mb-6">Select a property for autopilot cleaning</h2>

      <core-property-radio-group
        [propertyFilters]="marketplacePropertyFilter"
        (propertySelected)="onPropertySelected($event)" />
    }
    @case ('auto-info') {
      @if (payload().property) {
        <sbnb-add-task-rule-flow-property-display [property]="payload().property" />
      }
    }
    @case ('auto-cleaning-details') {
      <sbnb-add-task-rule-flow-cleaning-details
        [property]="payload().property"
        [rooms]="propertyCleansterData()?.room_count || 0"
        [bathrooms]="propertyCleansterData()?.bathroom_count || 0"
        [cleaningHours]="payload().cleaning_hours || 0"
        [recommendedCleaningTime]="propertyCleansterData()?.recommended_cleaning_time"
        [provideCleaningSupplies]="payload().provide_cleaning_supplies || false"
        [turnoIntegrationEnabled]="propertyCleansterData()?.turno_integration_enabled ?? false"
        [cleansterIntegrationEnabled]="propertyCleansterData()?.cleanster_integration_enabled ?? false"
        [resortCleaningIntegrationEnabled]="propertyCleansterData()?.resort_cleaning_integration_enabled ?? false"
        [tidyIntegrationEnabled]="propertyCleansterData()?.tidy_integration_enabled ?? false"
        (cleaningHoursChanged)="onCleaningHoursChanged($event)"
        (provideCleaningSuppliesChanged)="onProvideCleaningSuppliesChanged($event)" />
    }
    @case ('auto-checklist') {
      @if (aiSuggestionForChecklistRequested()) {
        <sbnb-add-task-rule-flow-checklist [property]="payload().property!" [(checklist)]="payload().checklist" />
      } @else {
        <div class="flex flex-col gap-4 items-center justify-center h-full">
          <ui-loading-spinner />
          <span>Generating cleaning checklist...</span>
        </div>
      }
    }
    @case ('auto-cleaners') {
      <sbnb-add-task-rule-flow-cleaners [cleaners]="cleaners()" [loading]="cleanersLoading()" />
    }
    @case ('auto-access') {
      <sbnb-add-task-rule-flow-access
        [createOperationCodes]="payload().create_operation_codes"
        [note]="payload().note || ''"
        [hasSmartlocks]="payload().property?.has_smartlocks || false"
        (createOperationCodesChanged)="onCreateOperationCodesChanged($event)"
        (noteChanged)="onNoteChanged($event)" />
    }
    @case ('auto-cost-and-payments') {
      <sbnb-add-task-rule-flow-cost-and-payments
        [estimatedCostPerClean]="propertyCleansterData()?.estimated_cost_display"
        [paymentMethodDetails]="paymentMethodDetails()"
        [paymentMethodDetailsLoading]="paymentMethodDetailsLoading()" />
    }
    @case ('auto-confirm') {
      <sbnb-add-task-rule-flow-confirm
        [turnoIntegrationEnabled]="propertyCleansterData()?.turno_integration_enabled ?? false"
        [cleansterIntegrationEnabled]="propertyCleansterData()?.cleanster_integration_enabled ?? false"
        [resortCleaningIntegrationEnabled]="propertyCleansterData()?.resort_cleaning_integration_enabled ?? false"
        [tidyIntegrationEnabled]="propertyCleansterData()?.tidy_integration_enabled ?? false" />
    }
  }

  <!-- Custom footer with estimated cost display -->
  <div footerActions class="flex items-center justify-between w-full gap-4">
    <!-- Secondary action button -->
    @if (secondaryAction()) {
      <ui-button
        [label]="secondaryAction().label"
        [loading]="secondaryAction().loading ?? false"
        [disabled]="secondaryAction().disabled ?? false"
        (click)="secondaryAction().onClick()"
        size="lg"
        variant="tertiary" />
    }

    <!-- Centered estimated cost display -->
    @if (propertyCleansterData()?.estimated_cost_display && activeStep() !== 'auto-confirm') {
      <span class="text-success-600 font-medium text-center flex-1">
        Estimated cost per clean: {{ propertyCleansterData()?.estimated_cost_display }}
      </span>
    } @else {
      <span class="flex-1"></span>
    }

    <!-- Primary action button -->
    @if (primaryAction()) {
      <ui-button
        [label]="primaryAction().label"
        [loading]="primaryAction().loading ?? false"
        [disabled]="primaryAction().disabled ?? false"
        (click)="primaryAction().onClick()"
        size="lg" />
    }
  </div>

  <!-- <pre>Payload (debug): {{ payload() | json }}</pre> -->
</ui-modal-full>
